// extracted by mini-css-extract-plugin
export default {"input":"Numbers_input__B3+Yt","message":"Numbers_message__d2E9M"};